import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
const purchases = [{
  name: 'Carlos',
  location: 'Madrid',
  time: '2 minutos'
}, {
  name: 'María',
  location: 'Buenos Aires',
  time: '5 minutos'
}, {
  name: 'Mateo',
  location: 'Córdoba',
  time: '1 minuto'
}, {
  name: 'Juan',
  location: 'México DF',
  time: '30 segundos'
}, {
  name: 'Sofía',
  location: 'Bogotá',
  time: '3 minutos'
}, {
  name: 'Alejandro',
  location: 'Santiago',
  time: '4 minutos'
}, {
  name: 'Valentina',
  location: 'Lima',
  time: '1 minuto'
}];
export function RecentPurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, 12000);
    return () => clearInterval(interval);
  }, []);
  return <div className={`fixed bottom-4 left-4 z-50 w-[90%] max-w-[320px] bg-slate-900/95 backdrop-blur-md rounded-xl shadow-2xl border border-slate-700 transition-all duration-700 ease-in-out ${visible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95 pointer-events-none'}`} data-id="element-264">
      <div className="p-4 flex items-start" data-id="element-265">
        <div className="bg-brand-500/20 p-2 rounded-full mr-3 mt-0.5" data-id="element-266">
          <CheckCircleIcon className="h-5 w-5 text-brand-400" data-id="element-267" />
        </div>
        <div className="flex-1" data-id="element-268">
          <div className="flex justify-between items-center mb-1" data-id="element-269">
            <span className="text-sm font-bold text-slate-200" data-id="element-270">
              Nueva compra
            </span>
            <span className="text-xs text-slate-400" data-id="element-271">
              Hace {currentPurchase.time}
            </span>
          </div>
          <p className="text-sm text-slate-300" data-id="element-272">
            <span className="font-semibold text-white" data-id="element-273">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.location} compró El Código de Micro-Señales
          </p>
        </div>
      </div>
    </div>;
}